// extracted by mini-css-extract-plugin
export default {"container":"BalanceSheet_container__rn6Hp","tableContainer":"BalanceSheet_tableContainer__EMalL"};